export class PieChartOptions {
    series: any = {
        pie: {
            innerRadius: .7,
            show: true,
            stroke: {
                color: "#222a33"
            },
            label: {
                show: false,
                // radius: .7,
                formatter: labelFormatter,
            }
        },

    };
    grid: any = {
        hoverable: true,
    };
    colors: any[];
    legend: any;
    legendSelector: string;
    height: number = 150;
    needRemainingPercentage: boolean = false;
    tooltip: boolean = true;
    tooltipOpts: any = {
        content: function (label, series) {
            var element = "<span id='tooltip' style='background: #222a33; padding: 8px; border: 3px solid'> <span id='triangle'></span> <span id='triangle-small'></span>%p.0%</span>";
            return element;
        },
        shifts: {
            x: 20,
            y: -50
        },
        defaultTheme: false
    }
}

function labelFormatter(label, series) {
    if (series.percent > 10) {
        let className = '';
        let angle = series.startAngle;
        if (angle >= 0 && angle < 5)
            className = " 'pie-label triangle-bl' "; //bottom-left
        if (angle > 5 && angle < 7)
            className = " 'pie-label triangle-tl' "; //top-left
        if (angle >= 7 && angle < 9)
            className = " 'pie-label triangle-tr' "; //top-right
        if (angle >= 9)
            className = " 'pie-label triangle-br' "; //bottom-right 
        if (angle > 7 && angle < 7.2)
            className = " 'pie-label triangle-tl' "; //top-left
        return "<div style='border-color: " + series.color + " ' class=" + className + ">" + "<span style='border-color: " + series.color + " ' class='label-triangle'></span><span style='border-color: " + series.color + " ' class='label-triangle-small'></span>" + Math.round(series.percent) + "%</div>";
    } else {
        return "<div></div>";
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/chart/pie-chart-options.model.ts